export default {
  aawzDrive: {
    loading: false,
    uploadLoading: false,
    lastUpdate: null,
    data: {},
    allowedExtensions: [],
  },
}
